<h3>Processing Queues</h3>
@if (sqsQueueSummary !== undefined) {
  <div>
    <table class="table table-bordered">
      <thead class="table-dark">
        <tr>
          <th>FULL FILE QUEUE COUNT</th>
          <th>FILE PART QUEUE COUNT</th>
          <th>REFERRAL QUEUE COUNT</th>
          <th>ENCOUNTER QUEUE COUNT</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{sqsQueueSummary.fullFileCount}}</td>
          <td>{{sqsQueueSummary.filePartsCount}}</td>
          <td>{{sqsQueueSummary.referralCount}}</td>
          <td>{{sqsQueueSummary.encounterCount}}</td>
        </tr>
      </tbody>
    </table>
  </div>
} @else {
  <mat-spinner diameter="30" />
}
<h3>File Monitoring</h3>
<div class="mb-3">
  <form novalidate (ngSubmit)="onFormEnter($event)">
    <div class="row g-0 flex-row align-items-end">
      <div class="col-4">
        <div class="my-0 py-0 me-2">
          <label class="my-0"><strong>Client</strong></label>
          <app-client-select
            name="clientIds"
            placeholder="Filter by Client"
            [multiple]="true"
            [autoLoad]="true"
            [listFilters]="{ applicableToReferralClaims: true }"
            [(selectedIds)]="formModel.selectedClientIds"
            (changed)="onClientChange()"/>
        </div>
      </div>
      <div class="col-2">
        <div class="my-0 py-0 me-1">
          <label class="my-0"><strong>Filename</strong></label>
          <div class="input-group filename">
            <input
              [(ngModel)]="formModel.filename"
              name="filename"
              class="form-control"
              [ngClass]="{ 'has-value': hasFilename }"
              (keydown)="onFilenameKeyDown($event)"
              (keyup)="onFilenameKeyUp()"
              placeholder="my_referrals.csv"
              />
            @if (hasFilename) {
              <button class="btn btn-outline-secondary px-2" type="button" (click)="onClearFilenameClick()">
                <span aria-hidden="true" class="fs-5 lh-1">×</span>
              </button>
            }
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="mb-2 me-2">
          <mat-slide-toggle
            name="withErrors"
            labelPosition="before"
            [color]="'primary'"
            [(ngModel)]="formModel.withErrors"
            [disableRipple]="true"
            (change)="onWithErrorsChange()">
            <strong>Errors</strong>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-2">
        <button type="button" class="btn btn-info ms-1 mt-0 clear-button" (click)="onClearAllClick($event)">Clear All</button>
        <button type="submit" class="visually-hidden" aria-hidden="true" tabindex="-1">Search</button>
      </div>
    </div>
  </form>
</div>
@if (!loading) {
  <div>
    @if (clientFiles.length > 0) {
      <div>
        <app-pagination-header [paging]="paging" [label]="'clientFiles'" (pageSizeChange)="onPageSizeChange($event)" />
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th class="text-nowrap">ID</th>
              <th>CREATED</th>
              <th>CLIENT</th>
              <th class="text-nowrap">FILENAME</th>
              <th class="text-nowrap">TYPE</th>
              <th class="text-nowrap">ROWS</th>
              <th class="text-nowrap">ERRS</th>
            </tr>
          </thead>
          <tbody>
            @for (clientFile of clientFiles; track clientFile) {
              <tr>
                <td>{{clientFile.id}}</td>
                <td>{{clientFile.createdAt | date: 'MM/dd/yyyy h:mm a' }}</td>
                <td>
                  {{clientFile.client.name}}
                  @if (!clientFile.client.fileProcessingEnabled) {
                    <div class="processing-disabled text-danger">processing disabled</div>
                  }
                  @if (clientFile.client.claimIdentifierPrefix?.length === 0) {
                    <div class="processing-disabled text-danger">claim identifier prefix not set</div>
                  }
                </td>
                <td>{{clientFile.fileName}}</td>
                <td>{{clientFile.kind}}</td>
                <td class="text-center">{{clientFile.totalRows}}</td>
                @if (clientFile.errorCount > 0) {
                  <td class="text-center">
                    <a href="#" (click)="onDownloadErrorsClick($event, clientFile)">
                      {{clientFile.errorCount}}
                    </a>
                  </td>
                }
                @if (clientFile.errorCount === 0) {
                  <td class="text-center">
                    {{clientFile.errorCount}}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
      </div>
    } @else {
      <section>
        <p>
          There are no client files. Try modifying the filters or
          <strong
            ><u><a href="#" (click)="onClearAllClick($event)">clearing them</a></u></strong
            >.
          </p>
        </section>
      }
    </div>
  } @else {
    <mat-spinner diameter="30" />
  }

